<template>
    <div class="container">
        <h2 class="title is-5">head要素のtitleとdescritptionの変更</h2>
        <p>head要素のtitleとdescritptionの変更する場合のサンプルコード。</p>
        <p>SEO対策として有効です。タイトルを確認してみてください。</p>
        <b-tag type="is-info">Vue.js</b-tag>
        <hr/>
        <h3 class="title is-5">サンプル</h3>
        <HeadMetaComponent />
        <hr/>
        <p class="title is-5">コード</p>
        <p style="margin-bottom:10px;"><b-button @click="twitterShare" class="is-info" size="is-small"><i class="fab fa-twitter"></i>シェアする</b-button></p>
        <div class="iframely-embed"><div class="iframely-responsive" style="padding-bottom: 56.2493%;"><a href="https://gist.github.com/katonobo/ccc0619111e5649234ee1ab281419aab" data-iframely-url="//cdn.iframe.ly/bkc0DTb"></a></div></div>
        <hr>
        <p class="title is-5">解説</p>
        <p>SPAは、routerでページを遷移してもhead要素が変更されません。SEO対策として書き換えをする必要があります。</p>
        <p>このサンプルでは、mounted()内でhead要素を書き換えています。</p>
        <p style="color:red;">titleとdescriptionを書き換える元としてindex.htmlで事前に設定が必須です</p>
    </div>
</template>

<script>
import HeadMetaComponent from  '@/components/HeadMetaComponent.vue'
export default {
    components:{
        HeadMetaComponent
    },
    mounted(){  
        window.iframely.load();
    },
    methods:{
        twitterShare(){
            var shareURL = 'https://twitter.com/intent/tweet?text=' + "head要素のtitleとdescritptionの変更のサンプルコード" + "%20%23あめねこサンプルコード集" + '&url=' + "https://code.ameneko.com/head-meta-change";  
            location.href = shareURL
        }
    }
}
</script>

<style scoped>
.container{
    max-width: 1000px;
    margin:auto;
    margin-bottom: 40px;
    padding: 10px;
}

</style>